import Swiper, { Navigation, FreeMode } from 'swiper';
import 'swiper/css';

/**
 * This module provides a slideshow
 */
 export class QuotesModule {

    static name = 'quotes';

    constructor(node) {

        this.node = node;

        this.swiper = new Swiper(node, {
            slidesPerView: 1,
            spaceBetween: 24,
            loop: false,
            centeredSlides: true,
            modules: [Navigation],
            navigation: {
              nextEl: '.quotes-button.next',
              prevEl: '.quotes-button.prev',
            },
        });
    }
}

  